import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, NavigationStart } from '@angular/router';

import { tap, filter, takeUntil } from 'rxjs/operators';

import { DlgStoreCpuUnlockComponent } from './dlg-store-cpu-unlock';
import { TRANSFER_UNLOCK, ACTIVATE_UNLOCK } from './dlg-store-cpu-unlock';
export { TRANSFER_UNLOCK, ACTIVATE_UNLOCK } from './dlg-store-cpu-unlock';

import { UserService } from '../shared-services.module/user.service';
import { SteamService } from '../shared-services.module/steam.service';

import { ToastrService } from '../toastr.module/toastr.service';
import { ToastTransferingCpuUnlockComponent } from '../toastr.module/toast-transfering-cpu-unlock.component';
import { ToastSuccessCpuUnlockComponent } from '../toastr.module/toast-success-cpu-unlock.component';

const PKG_CPU_UNLOCK = 'cpuUnlock';

interface IDlgStoreCpuUnlockData {
    steam: any;
    amount: number;
    lifetimeSubscription: boolean;
}

@Injectable()
export class ShowDlgStoreCpuUnlockService {
    dialogRef: MatDialogRef<DlgStoreCpuUnlockComponent>;

    resolve: (value?: any) => void;
    reject: (reason?: any) => void;

    set disabled(value: boolean) {
        if (this.dialogRef.componentInstance) {
            this.dialogRef.componentInstance.disabled = value;
        }
    }

    constructor(
        private _router: Router,
        private _dialog: MatDialog,

        private _toastrSrv: ToastrService,
        private _userSrv: UserService,
        private _steamSrv: SteamService,
    ) {
    }

    show(data: IDlgStoreCpuUnlockData): Promise<any> {
        this.dialogRef = this._dialog.open(DlgStoreCpuUnlockComponent, {
            backdropClass: 'mat-backdrop--long-scroll',
            panelClass: ['--ui'],
            data: {
                ...data,

                close: () => this.close(),
                transfer: (...args) => this.transfer(args[0]),
                activate: (...args) => this.activate(args[0])
            }
        });

        this._router.events
            .pipe(takeUntil(this.dialogRef.afterClosed()))
            .pipe(filter(e => e instanceof NavigationStart))
            .pipe(tap(() => this.close()))
            .subscribe();

        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    close() {
        this.dialogRef.close();
    }

    async transfer(count: any) {
        this.dialogRef.close();

        const toastTransferingRef = this._toastrSrv.show(ToastTransferingCpuUnlockComponent, {
            timeout: 3000,
            data: {
                transfering: count
            }
        });

        try {
            await this._steamSrv.pushResources({ resourceType: PKG_CPU_UNLOCK, amount: count });
        } catch (err) {
            console.error('inventory/base::dlgStorePixelSrv', err);
            this.reject(err);
            return;
        }

        toastTransferingRef.close();

        this._toastrSrv.show(ToastSuccessCpuUnlockComponent, {
            data: {
                count,
                message: 'transfered to Steam'
            }
        });

        this.resolve({ type: TRANSFER_UNLOCK, payload: count });
    }

    async activate(count: any) {
        this.dialogRef.close();

        try {
            await this._userSrv.activateCpuUnlock(count);
        } catch (err) {
            console.error('inventory/base::dlgStorePixelSrv', err);
            this.reject(err);
            return;
        }

        this._toastrSrv.show(ToastSuccessCpuUnlockComponent, {
            data: {
                count,
                message: 'Activated'
            }
        });

        this.resolve({ type: ACTIVATE_UNLOCK, payload: count });
    }
}
